export const CommunityAdminFormatDate = (date: string) => {
    const d = new Date(date);
    return [
        String(d.getDate()).padStart(2, '0'),
        d.toLocaleString('en-US', { month: 'short' }),
        d.getFullYear()
    ].join(' ');
}